import { numberFormat } from '@packages/toolbox/dist/utils/numbers';
import { FilePropValidationRule } from 'SharedDir/constants/files';
import { AttachmentType, RejectedFile } from 'SharedDir/declarations/files';
import { MakeDictionary } from 'SharedDir/utils/helpers';

export const mapFileTypeToExtensions = {
  image: ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'jfif', 'jpe', 'gif', 'webp', 'svg'],
  audio: ['ogg', 'mp3', 'wav', 'wma'],
  doc: ['doc', 'docx', 'odt', 'pdf', 'docm', 'rtf', 'txt'],
  pdf: ['pdf'],
  table: ['xls', 'xlsx', 'xlsb', 'csv', 'tsv'],
  export: ['docx', 'xlsx'],
  any: ['*'],
};

const FilePropValidations = [
  { value: FilePropValidationRule.maxFileSize, label: 'Максимальный размер файла, Кбайт' },
  { value: FilePropValidationRule.accept, label: 'Расширение файла должно быть' },
  { value: FilePropValidationRule.maxTotalSize, label: 'Максимальный итоговый размер, Кбайт' },
  { value: FilePropValidationRule.maxFiles, label: 'Превышено максимальное количество файлов' },
  { value: FilePropValidationRule.filter, label: 'Набор файлов не прошел через фильтр' },
];
/**
 * Словарь для причин непрошедшей валидации файлов
 *
 */
const FilePropValidationDict = MakeDictionary(FilePropValidations, 'value', 'label');

/**
 * Метод дает словестное описание ошибки валидвиции файла
 *
 * @param {RejectedFile} rejected
 * @param {Partial<Record<FilePropValidationRule, string | number>>} rules
 * @returns {string}
 * @constructor
 */
export const MakeFileFailedDescription = (
  rejected: RejectedFile,
  rules: Partial<Record<FilePropValidationRule, string | number>>
): string => {
  const rule = FilePropValidationDict[rejected.failedPropValidation];
  if (rejected.failedPropValidation === FilePropValidationRule.maxFileSize) {
    const { file } = rejected;
    const fileSize = numberFormat(Math.ceil(file.size / 1024));
    const maxSize = numberFormat(rules[rejected.failedPropValidation] as number) || '';
    return `${rule}: ${maxSize}кб,
       а ${file.name} имеет размер ${fileSize}кб!`;
  }
  if (rejected.failedPropValidation === FilePropValidationRule.accept) {
    const accept = (rules[rejected.failedPropValidation] as string) || '';
    const allowed = accept.replaceAll(',.', ', .');
    return `${rule}: ${allowed}!`;
  }
  if (rejected.failedPropValidation === FilePropValidationRule.maxFiles) {
    const max = rules[rejected.failedPropValidation] || '';
    const { file } = rejected;
    return `${rule}: ${max} - ${file.name} не загружен!`;
  }
  // TODO: додклать вывод русских ошибок для остальных выидов валидации
  return rejected.failedPropValidation;
};

export default class Attachment {
  id!: string;

  name!: string;

  isPublic!: boolean;

  authorizedOnly!: boolean;

  isImage!: boolean;

  constructor({ id, isPublic, authorizedOnly, name, isImage }: AttachmentType) {
    this.id = id;
    this.name = name;
    this.isPublic = isPublic;
    this.authorizedOnly = authorizedOnly;
    this.isImage = isImage;
  }
}
